import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import NutritionDrawerSectionTitle from "../common/NutritionDrawerSectionTitle";
import {
  nutritionPairDescription,
  nutritionPairTitle,
  NutritionTargetPairs,
} from "../../../constants";

import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  description: {
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      paddingInline: theme.spacing(2),
    },
  },
}));

export interface TargetTypeInfoProps {
  pair: NutritionTargetPairs;
  onChangeSchedule: () => void;
  className?: string;
}

const TargetTypeInfo: FC<TargetTypeInfoProps> = ({
  className,
  pair,
  onChangeSchedule,
}) => {
  const s = useStyles();
  return (
    <Box className={className}>
      <NutritionDrawerSectionTitle
        title={nutritionPairTitle[pair]}
        action={{
          name: "Change schedule",
          onClick: onChangeSchedule,
        }}
      />
      <Typography
        className={s.description}
        variant="body2"
        color="textSecondary"
      >
        {nutritionPairDescription[pair]}
      </Typography>
    </Box>
  );
};

export default TargetTypeInfo;
